import * as THREE from 'three';
import Experience from '../Experience';

export default class ameAndBonfire
{
  constructor()
  {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.time = this.experience.time;
    this.debug = this.experience.debug;

    // Setup
    this.resources = this.resources.items.ameAndBonfireNoFire;
    this.setModel();
    this.setAnimation();
    this.setDebug(); // デバッグ機能を追加
  }

  setModel()
  {
    this.model = this.resources.scene;
    this.model.scale.set(1.0, 1.0, 1.0);
    this.model.position.set(-4.09, -0.65, 17.05);
    this.model.rotation.set(0.51840, 1.67840, -0.6415)
    this.scene.add(this.model);

    // console.log(this.resources)
  }

  setAnimation()
  {
    // Animation setup can be added here if needed
    this.animation = {}
    this.animation.mixer = new THREE.AnimationMixer(this.model);

    this.animation.actions = {};
    this.animation.actions.idle = this.animation.mixer.clipAction(this.resources.animations[0]);

    this.animation.actions.current = this.animation.actions.idle;
    this.animation.actions.current.play();
    console.log(this.model);
  }

  setDebug()
  {
    // デバッグが有効な場合のみデバッグUIを作成
    if(this.debug.active)
    {
      // 「spaceAmeCamping」という名前のフォルダーを作成
      this.debugFolder = this.debug.ui.addFolder('spaceAmeCamping');

      // 位置のデバッグコントロール
      this.debugFolder.add(this.model.position, 'x')
        .name('Position X')           // 表示名
        .min(-20).max(20)            // 最小値・最大値
        .step(0.01);                 // ステップサイズ
        
      this.debugFolder.add(this.model.position, 'y')
        .name('Position Y')
        .min(-20).max(20)
        .step(0.01);
        
      this.debugFolder.add(this.model.position, 'z')
        .name('Position Z')
        .min(-20).max(20)
        .step(0.01);

      // 回転のデバッグコントロール
      // Three.jsでは回転はラジアンで管理されるので、範囲は-Math.PI〜Math.PIが適切
      this.debugFolder.add(this.model.rotation, 'x')
        .name('Rotation X')
        .min(-Math.PI).max(Math.PI)  // -180度〜180度（ラジアン）
        .step(0.01);
        
      this.debugFolder.add(this.model.rotation, 'y')
        .name('Rotation Y')
        .min(-Math.PI).max(Math.PI)
        .step(0.01);
        
      this.debugFolder.add(this.model.rotation, 'z')
        .name('Rotation Z')
        .min(-Math.PI).max(Math.PI)
        .step(0.01);

      // フォルダーを最初は閉じておく（お好みで開いておきたい場合はコメントアウト）
      this.debugFolder.close();
    }
  }

  update()
  {
    this.animation.mixer.update(this.time.delta * 0.001); // Update the animation mixer with delta time
  }
}